export { default as DefaultPage } from './DefaultPage';



// WEBPACK FOOTER //
// ./src/features/school-classes/index.js